import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Get the root element
const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}

// Create React root
const root = ReactDOM.createRoot(container);

// Render the app
// Temporarily disabled StrictMode for auth debugging
root.render(
  <App />
); 